// Services
import callAPI from "../callApi";
import path from "../variables";

const User = {
	getAll: async (filter: string) =>
		await callAPI(
			"GET",
			`${path.base}/administration/users${filter ? filter : ""}`,
			"",
			"getting all users"
		),
	getProfile: async (id: any) =>
		await callAPI(
			"GET",
			`${path.base}/administration/users/${id}`,
			"",
			"getting full user profile (roles, stations, permissions)",
			// skipCache : le drawer détail est ÉDITÉ (assign/retrait de rôle &
			// d'agence) puis re-fetché immédiatement. Sans ça, le re-fetch
			// post-mutation était servi depuis le cache GET 60s → les chips
			// rôles/agences ne se mettaient à jour qu'au ré-ouvrage du drawer.
			{ skipCache: true }
		),
	getUserInfosWithID: async (id: any) =>
		await callAPI("GET", `${path.base}/users/${id}`, "", "getting user infos with ID"),
	getUserInfos: async () =>
		await callAPI("GET", `${path.base}/user/infos`, "", "retrieving user details"),
	editUserInfos: async (id: string, data: any) =>
		await callAPI("PUT", `${path.base}/users/${id}`, data, "updating user infos"),
	editPassword: async (data: any) =>
		await callAPI("POST", `${path.base}/user/password`, data, "updating password"),

	// Attach (idempotent via syncWithoutDetaching) one or more roles to a user
	attachRoles: async (data: { station: string; user: string; roles: { uuid: string }[] }) =>
		await callAPI("POST", `${path.base}/settings/user-roles`, data, "attaching roles to user"),

	// Detach one or more roles from a user
	detachRoles: async (data: { station: string; user: string; roles: { uuid: string }[] }) =>
		await callAPI("PUT", `${path.base}/settings/user-roles/detach`, data, "detaching roles from user"),

	// Attach a station to a user (idempotent — backend uses syncWithoutDetaching).
	attachStation: async (data: { station: string; user: string }) =>
		await callAPI("POST", `${path.base}/administration/add-user-to-station`, data, "attaching station to user"),

	// Detach a station from a user. Backend refuses to leave the user with zero stations.
	detachStation: async (data: { station: string; user: string }) =>
		await callAPI("POST", `${path.base}/administration/remove-user-from-station`, data, "detaching station from user"),
};

export default User;
